import { FtlRoutingViewModel } from "../../ViewModel/FtlRoutingViewModel";
import { RoutingType } from "../../ViewModel/RoutingType";

export function createDockObjectForUndefindedPlant(databasePlant: FtlRoutingViewModel) {
  const dockObjectForUndefindedPlant: Array<FtlRoutingViewModel> = [
    {
      GeoLocation: databasePlant.GeoLocation,
      RoutingType: RoutingType.Dock,
      PuDoType: databasePlant.PuDoType,
      Gsdb: databasePlant.Gsdb,
      Dock: databasePlant.Dock,
      DockCode: databasePlant.DockCode,
      LocationName: databasePlant.LocationName,
      City: "",
      Postcode: "",
      Country: "",
      ETA: "N/A",
      ETD: "N/A",
      Km: 0,
      Day: 0,
      DrivingHours: "0",
      OrderNumber: 0,
      Modified: true,
    },
  ];
  return dockObjectForUndefindedPlant;
}
